import { IPlaceService } from './../iPlace/iPlace.service';
import { I18NService } from './../shared/i18n/i18n.service';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PetrolRankingComponent } from './PetrolRanking.component';
import { PetrolRankingService } from './PetrolRanking.service';
import { AgmCoreModule } from '@agm/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { FlexLayoutModule } from '@angular/flex-layout';
import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown';

@NgModule({
  imports: [
    FlexLayoutModule,
    CommonModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyBwF8edJ94o3J9OpSJTtDdiLeqbWslS1AM'
    }),
    FormsModule,
    ReactiveFormsModule,
    BsDatepickerModule,
    AngularMultiSelectModule
  ],
  exports: [
    PetrolRankingComponent
  ],
  declarations: [PetrolRankingComponent],
  providers: [PetrolRankingService, I18NService, IPlaceService]
})
export class PetrolRankingModule { }
